import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { HashRouter as Router, Redirect, Route } from 'react-router-dom';
import { Account } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';

import accountTheme from '../../theme/theme';
import '../../theme/variables.css';
import Head from '@websky/core/src/Head';
import { RenderersProvider } from '@websky/core/src/renderProps';
import { izaviaRenderers } from '../renderProps';

const AccountComponent: React.FC = () => {
	return (
		<Router>
			<RenderersProvider value={izaviaRenderers}>
				<ThemeProvider value={accountTheme}>
					<Head />
					<Route exact path="/" render={() => <Redirect to="/account" />} />
					<Account />
				</ThemeProvider>
			</RenderersProvider>
		</Router>
	);
};

export default AccountComponent;
